import { HttpInterceptorFn } from '@angular/common/http';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const isFormData = req.body instanceof FormData;
  const authRequest = req.clone({
    ...(isFormData || req.headers.has('Content-Type')
      ? {}
      : { setHeaders: { 'Content-Type': 'application/json' } }),
    withCredentials: true,
  });

  return next(authRequest);
};
